import * as React from "react";
import {Fragment} from "react";
import Loading from "../ui/loading/Loading";
import {none, option, Option} from "ts-option";
import AppointmentsTable from "./AppointmentsTable";
import * as moment from "moment";
import {withRouter} from "react-router";
import SectionView from "../layout/section/SectionView";
import PageContentView from "../body/PageContentView";
import DateRangePickerComponent from "../ui/datepicker/DateRangePickerComponent";
import {AppointmentListFilters} from "../../store/local/model/AppointmentListFilters";
import LocalStorage from "../../store/local/LocalStorage";
import AppointmentDetails from "../../model/appointment/AppointmentDetails";
import {notifyBugsnagAndShowToast} from "../../utils/Utils";
import {OnSuccessData} from "../../store/action/actionHelpers";
import {fetchJobsAppointmentsInDateRange, fetchLeadsAppointmentsInDateRange} from "../../store/action/appointment/appointment";
import {Dispatch} from "redux";
import {connect} from "react-redux";

interface State {
	from: moment.Moment;
	to: moment.Moment;
	/**
	 * Appointments list stored filters object, containing dates selected by user.
	 */
	storedData: AppointmentListFilters;
	appointments: Option<AppointmentDetails[]>
}

interface DispatchProps {
	fetchLeadsAppointmentsInDateRange: (dateFrom: moment.Moment,
		dateTo: moment.Moment,
		onSuccess: OnSuccessData<AppointmentDetails[]>) => void
	fetchJobsAppointmentsInDateRange: (dateFrom: moment.Moment,
		dateTo: moment.Moment,
		onSuccess: OnSuccessData<AppointmentDetails[]>) => void
}

class AppointmentList extends React.PureComponent <DispatchProps, State> {

	constructor(props: DispatchProps) {
		super(props);
		const storedData = LocalStorage.getAppointmentListFilters();
		this.state =
			{from: moment(storedData.dateFrom), to: moment(storedData.dateTo), storedData: storedData, appointments: none};
	}

	componentDidMount() {
		this.fetchAppointments()
	}

	fetchAppointments = () => {
		this.setState({appointments: none}, () => {
			const onSuccess = (app: AppointmentDetails[]) => this.setState(
				{appointments: option(this.state.appointments.getOrElse([]).concat(app).sort(AppointmentDetails.compare))})
			this.props.fetchLeadsAppointmentsInDateRange(this.state.from, this.state.to, onSuccess);
			this.props.fetchJobsAppointmentsInDateRange(this.state.from, this.state.to, onSuccess);
		})
	}

	render() {
		const appointments = this.state.appointments.getOrElse([]).map(ad => ad.appointment)

		return (
			<Fragment>
				<PageContentView>
					<SectionView>
						<DateRangePickerComponent from={this.state.from}
												  to={this.state.to}
												  onChange={this.onDateChange}
												  range={2}/>
					</SectionView>

					<Loading isLoading={this.state.appointments.isEmpty}>
						{appointments.length > 0 &&
						<AppointmentsTable style={{marginLeft: "0px", marginRight: "0px"}}
										   appointments={option(appointments)}
										   readonly
										   tableCustomClass={"table-hover tr-pointer appointments-table"}
										   leadFormContactId={none}/>}
						{appointments.length == 0 &&
						<div className={"c-empty-view"}>
							<div className={"description"}>There are no appointments in the selected date range.</div>
						</div>}
					</Loading>
				</PageContentView>
			</Fragment>
		)
	}

	onDateChange = (from: moment.Moment, to: moment.Moment) => this.setState(
		{from, to, storedData: this.state.storedData.updateDateFrom(from).updateDateTo(to)}, this.fetchAppointments)
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchLeadsAppointmentsInDateRange: (dateFrom: moment.Moment,
			dateTo: moment.Moment,
			onSuccess: OnSuccessData<AppointmentDetails[]>) => dispatch(
			fetchLeadsAppointmentsInDateRange(dateFrom, dateTo, onSuccess,
				e => notifyBugsnagAndShowToast(e, "Fetch Leads appointments"))),
		fetchJobsAppointmentsInDateRange: (dateFrom: moment.Moment,
			dateTo: moment.Moment,
			onSuccess: OnSuccessData<AppointmentDetails[]>) => dispatch(
			fetchJobsAppointmentsInDateRange(dateFrom, dateTo, onSuccess,
				e => notifyBugsnagAndShowToast(e, "Fetch Jobs appointments")))
	}
}

export default withRouter(connect(null, mapDispatchToProps)(AppointmentList));
